export default {
  prepareSequenceImages: Array(31)
    .fill('')
    .map((v, i) =>
      require(`../../../Box_sequences/00_TV serif new_box/serifnew_box${i < 10 ? `0${i}` : i}.jpg`)
    ),
  designSliderImage: require('../../../product drawing/cat house.png'),
  designImageList: [
    {
      number: 1,
      side: 'BOTTOM',
      image: require('../../../parts/cathouse/01.png'),
    },
    {
      number: 2,
      text: '-a',
      side: 'FRONT',
      image: require('../../../parts/cathouse/02.png'),
    },
    {
      number: 2,
      text: '-b',
      side: 'BACK',
      image: require('../../../parts/cathouse/03.png'),
    },
    {
      number: 3,
      side: 'MIDDLE',
      image: require('../../../parts/cathouse/04.png'),
    },
    {
      number: 4,
      text: "-a",
      side: 'SIDE',
      image: require('../../../parts/cathouse/05.png'),
    },
    {
      number: 4,
      text: "-b",
      side: 'SIDE',
      image: require('../../../parts/cathouse/06.png'),
    },
    {
      number: 5,
      side: 'TOP1',
      image: require('../../../parts/cathouse/07.png'),
    },
    {
      number: 5,
      side: 'TOP2',
      image: require('../../../parts/cathouse/08.png'),
    },
  ],
  cutOutPartsImage: require('../../../parts/cathouse/09.png'),
  cutOutPartsFoldImage: require('../../../parts/cathouse/fold.png'),
  assembleSequenceImages: Array(58)
    .fill('')
    .map((v, i) =>
      require(`../../../sequences/27_cat_sequence2.0/pethouse${
        i < 10 ? `0${i}` : i
      }.jpg`)
    ),
  completeImage: require('../../../complete/cat_house.png'),
  completeImagePc: require('../../../complete/cat_house.png'),
};
